// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.issues-list {\n    overflow-y: auto;\n    max-height: 60vh;\n    scrollbar-width: 'thin';\n    -webkit-scrollbar: 12px;\n}\n", ""]);
// Exports
module.exports = exports;
